var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{staticClass:"sparkline-chart",staticStyle:{"display":"inline-block"},attrs:{"type":_vm.type,"height":_vm.height,"width":_vm.width,"options":_vm.sparkOptions,"series":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }